export const ADMIN_PROFILE = 'admin';
export const CLIENT_PROFILE = 'client';